import React from "react";

const SearchIcon = () => {
  return (
    <svg width="16px" height="21px" viewBox="0 0 16 21">
      <g
        id="new-checkmarks"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Artboard"
          transform="translate(-107.000000, -303.000000)"
          fill="#a8a8a8"
        >
          <g id="Group-2" transform="translate(107.000000, 303.000000)">
            <path
              d="M7.92,0 C12.2940952,0 15.84,3.54590478 15.84,7.92 C15.84,12.2940952 12.2940952,15.84 7.92,15.84 C3.54590478,15.84 0,12.2940952 0,7.92 C0,3.54590478 3.54590478,0 7.92,0 Z M7.92,1.44 C4.34119482,1.44 1.44,4.34119482 1.44,7.92 C1.44,11.4988052 4.34119482,14.4 7.92,14.4 C11.4988052,14.4 14.4,11.4988052 14.4,7.92 C14.4,4.34119482 11.4988052,1.44 7.92,1.44 Z"
              id="Combined-Shape"
            ></path>
            <path
              d="M11.52,14.4 L14.3582523,19.1304205"
              id="Line"
              stroke="#a8a8a8"
              strokeWidth="1.44"
              strokeLinecap="square"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default SearchIcon;
